import { fetchTours } from './fetchTours'

export const FETCH_CONFIG_BEGIN   = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async dispatch => {
  dispatch({ type: FETCH_CONFIG_BEGIN })
  const config = JSON.parse(localStorage.getItem('ylg_site_search_config'))
  if (config) {
    dispatch({ type: FETCH_CONFIG_SUCCESS, payload: config })
    dispatch(fetchTours())
  }
}
